import { FormInstance } from 'antd';

import { InitialTableActions } from 'types';

export const handleDeleteRow = ({
  record,
  onDeleteTableData,
}: {
  record: Record<string, unknown>,
  onDeleteTableData?: (id: number) => void;
}) => () => {
  const recordKey = record.key as number;

  onDeleteTableData?.(recordKey);
};

export const handleEditRow = ({
  form,
  record,
  setEditingKey,
}: {
  form?: FormInstance;
  record: Record<string, unknown>;
  setEditingKey?: (editKey: number) => void;
}) => () => {
  form?.setFieldsValue(record);
  setEditingKey?.(record.key as number);
};

export const handleApproveRow = <T extends Record<string, unknown>>({
  record,
  onPatchTableData,
}: {
  record: T,
  onPatchTableData?: (data: T, actionType: InitialTableActions.Approve) => void;
}) => () => {
  onPatchTableData?.(record, InitialTableActions.Approve);
};

export const handleToggleIsActiveRow = <T extends Record<string, unknown>>({
  record: { key, ...rest },
  onPatchTableData,
}: {
  record: T,
  onPatchTableData?: (data: T) => void;
}) => () => {
  const row = { ...rest, isActive: !rest.isActive };

  onPatchTableData?.(row as unknown as T);
};
